<app-layout>
  <app-layout-title>{{ 'ADDITIONAL_FIELDS.title' | translate }}</app-layout-title>

  <app-layout-actions>
    <button (click)="openAddFieldDialog()" color="primary" mat-stroked-button>
      <mat-icon>add</mat-icon>
      <mat-label>{{ 'COMMON.add' | translate }}</mat-label>
    </button>

    <button (click)="saveAdditionFields()" color="primary" mat-stroked-button>
      <mat-icon>save</mat-icon>
      <mat-label>{{ 'COMMON.save' | translate }}</mat-label>
    </button>
  </app-layout-actions>

  <app-layout-content>
    <app-table [dataSource]="dataSource"
      loadingType="all"
      [reloader]="reloader"
      [columns]="columns">

      <app-table-row [rowClasses]="rowClasses"></app-table-row>

      <ng-container *app-table-header="'field'">{{ 'ADDITION_FIELDS.TABLE.field' | translate }}</ng-container>
      <ng-container
      *app-table-header="'description'">{{ 'ADDITION_FIELDS.TABLE.description' | translate }}</ng-container>
      <ng-container *app-table-header="'value'">{{ 'ADDITION_FIELDS.TABLE.value' | translate }}</ng-container>
      <ng-container *app-table-header="'actions'">{{ 'ADDITION_FIELDS.TABLE.actions' | translate }}</ng-container>

      <ng-container *app-table-column="let addition, name: 'field'">
        <app-heading hAlign="center" [title]="addition.name" [subtitle]="addition.type"></app-heading>
      </ng-container>

      <ng-container *app-table-column="let addition, name: 'description'">
        {{ addition.description }}
      </ng-container>

      <ng-container *app-table-column="let addition, name: 'value'">
        @switch (addition.type) {
          @case ('SHORT_TEXT') {
            {{ addition.value }}
          }
          @case ('NUMERIC') {
            {{ addition.value }}
          }
          @case ('ADDITIONS_INDEX') {
            <app-heading hAlign="center" [title]="addition.value"
              [subtitle]="addition.required ? ('COMMON.required' | translate) : ('COMMON.optional' | translate)">
            </app-heading>
          }
          @case ('ENTITY') {
            <app-heading hAlign="center" [title]="getNameById(addition.id, addition.entity) | async"
              [subtitle]="addition.entity">
            </app-heading>
          }
          @case ('FILE') {
            <button [mdePopoverTriggerFor]="file"
              mdePopoverTriggerOn="click"
              color="primary"
              mat-button>
              {{ 'COMMON.preview' | translate }}
            </button>
            <mde-popover #file="mdePopover" [mdePopoverCloseOnClick]="false">
              <img [src]="'data:' + addition.extension + ';base64,' + addition.value" class="file-preview">
            </mde-popover>
          }
          @case ('SELECTABLE') {
            <mat-form-field class="readonly-wrapper">
              <mat-label>{{ addition.required ? ('COMMON.required' | translate) : ('COMMON.optional' | translate) }}</mat-label>
              <mat-select [value]="addition.selected">
                @for (value of addition.values; track value) {
                  <mat-option [value]="value.value" class="readonly-option">
                    {{ value.description }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @case ('RULE_SET') {
            <app-rule-view [rule]="addition.value"></app-rule-view>
          }
          @case ('SWITCHABLE') {
            <mat-checkbox [checked]="addition.value" class="readonly-checkbox">{{ 'COMMON.default_value' | translate }}</mat-checkbox>
          }
          @case ('SUBSET') {
            <div class="subset-list">
              @for (field of addition.schema; track field) {
                <div>
                  <app-heading hAlign="center" [title]="field.name"
                    [subtitle]="field.type">
                  </app-heading>
                </div>
              }
            </div>
          }
          @case ('GROUP') {
            <div class="subset-list">
              @for (field of addition.schema; track field) {
                <div>
                  <app-heading [subtitle]="field.type" [title]="field.name"
                    hAlign="center">
                  </app-heading>
                </div>
              }
            </div>
          }
        }
      </ng-container>

      <ng-container *app-table-column="let addition, name: 'actions'">
        @if (!isNewAdditionField(addition)) {
          <mat-checkbox (change)="addFieldForRemoving($event, addition)"
            color="warn">
          </mat-checkbox>
        } @else {
          <button (click)="removeNewAdditionField(addition)" color="warn" mat-icon-button>
            <mat-icon>delete_outline</mat-icon>
          </button>
        }

      </ng-container>

    </app-table>
  </app-layout-content>
</app-layout>
